import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from "@angular/router";
import { tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AlertService } from '../shared/services/alert.service';
import { Utils } from './utils';
import { AuthService } from '../auth';
import { JwTokenModel } from './api/models';
import { MiniProfilerService } from './services/mini-profiler.service';
import { AcademyModeService, SparkMode } from './services/academy-mode.service';


@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  timer: any;
  private expiredTokenRefreshInProgress = false;
  constructor(private router: Router,

    private alertService: AlertService,

    private authService: AuthService,
    private http: HttpClient,
    private profiler: MiniProfilerService,
    private academyModeService: AcademyModeService

  ) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // add authorization header with jwt token if available
    // Use path check so API requests are detected for both relative ('/api/...') and absolute (e.g. 'https://host/api/...') URLs (QA/prod often use empty webApiRoot or different base URLs)
    var isAPIRequest = request.url.includes('/api/');

    if (isAPIRequest) {
      const modeId = this.academyModeService.getCurrentSparkModeId();
      let params = request.params.set('sparkMode', String(modeId));
      if (modeId === SparkMode.Academy) {
        params = params.set('academyMode', '1');
      } else {
        params = params.delete('academyMode');
      }
      request = request.clone({ params });

      //get the token from the local storage
      const token = localStorage.getItem('tokenInfo');
      if (token) {
        const newTokenInfo = JSON.parse(token) as JwTokenModel;
        //if the token on localSotrage will expire after the current token, then use the token on local storage
        if (newTokenInfo.expires_at && new Date(newTokenInfo.expires_at) > new Date(this.authService.tokenInfo?.expires_at || 0)) {
          this.authService.tokenInfo = newTokenInfo;
          this.authService.tokenInfo$.next(newTokenInfo);
        }
      }
      request = request.clone({
        setHeaders: {
          Authorization:
            this.authService.isSignedIn() ? `Bearer ${this.authService.tokenInfo?.access_token}` : '',
          clientname: this.authService.getClientFromUrl()
          //'x-api-version': `${environment.apiServer.apiVersion}`
        }
      });      
    }

    // Also handle errors globally
    return next.handle(request).pipe(tap({
      next: (event: HttpEvent<any>) => {

        if (event instanceof HttpErrorResponse) {

        }
        if (event instanceof HttpResponse) {

          // do stuff with response if you want


          if (isAPIRequest
            && this.authService.isSignedIn()
            && new Date(this.authService.tokenInfo?.expires_at || 0) < Utils.addMinutes(new Date(), 30)
            && this.authService.tokenInfo?.refresh_token
            && this.authService.tokenInfo?.refresh_expires_at
            && new Date(this.authService.tokenInfo.refresh_expires_at) > new Date()) {
            // If we are close to the token expiration, refresh it
            const refreshingToken = localStorage.getItem('refreshingToken') == this.authService.tokenInfo?.expires_at;
            if (!refreshingToken) {
              localStorage.setItem('refreshingToken', this.authService.tokenInfo!.expires_at!);
              this.authService.getTokenInfo().forEach(token => {
                console.debug('Token Refreshed', token?.expires_at);
                localStorage.removeItem('refreshingToken');
              });
            }
          }

          this.timerAutoLogout();

          if (!environment.production) {
            // https://github.com/MiniProfiler/dotnet/issues/502
            
            try {
              const miniProfilerIds = event.headers.get('X-MiniProfiler-Ids');
              if (miniProfilerIds) {
                this.profiler.fetch(JSON.parse(miniProfilerIds));
              }
            } catch (err) { }
          }

        }
      },
      error: err => {
        // Handle this err
        console.error(err, request.url);

      }
    }));

  }

  timerAutoLogout() {
    if (this.timer) {
      clearTimeout(this.timer);
    }

    this.timer = setTimeout(() => {

      let expires = this.authService.tokenInfo?.expires_at;
      if (!expires) {
        return;
      }
      var currentDate = new Date();
      var expireDate = new Date(expires);
      var remTime = Number(expireDate) - Number(currentDate);
      
      if (!isFinite(remTime) || remTime <= 0) {
        this.refreshExpiredTokenOrSignOut();
        return;
      }
      if (remTime < 300000) { //5 minutes left and not already showing confirm (need to add not already showing)
        this.authService.showSessionConfirm();
      }

      this.timerAutoLogout();
    }, 10000)
    
  }

  private refreshExpiredTokenOrSignOut() {
    this.authService.hideSessionConfirm();

    if (this.expiredTokenRefreshInProgress) {
      return;
    }

    if (!this.authService.hasUsableRefreshToken()) {
      this.signOutExpiredSession();
      return;
    }

    this.expiredTokenRefreshInProgress = true;
    this.authService.refreshTokenOnce().subscribe({
      next: token => {
        this.expiredTokenRefreshInProgress = false;
        if (token?.access_token && token.expires_at && new Date(token.expires_at) > new Date()) {
          this.timerAutoLogout();
          return;
        }

        this.signOutExpiredSession();
      },
      error: () => {
        this.expiredTokenRefreshInProgress = false;
        this.signOutExpiredSession();
      }
    });
  }

  private signOutExpiredSession() {
    this.authService.hideSessionConfirm();
    this.authService.signOut().subscribe();
  }
}
